/* eslint-disable @typescript-eslint/no-unused-vars */
import { CorePlanImage, VebPlanImage } from "./plan.image";
import { CorePlanShortDescription, VebPlanShortDescription } from "./plan.short.description";

export type FeaturedBenefits = {
	cardTitle: string;
	cardImage: string;
	cardDescription: string;
	planType: "CORE" | "VEB";
	planRedirectionRoute: string;
};

export type FeaturedBenefitsPlanListTypes = {
	corePlans: FeaturedBenefits[];
	vebPlans: FeaturedBenefits[];
};

//================================planShortDescription=======================
const {
	health_plan,
	clinic_card,
	gstd,
	gltd_class_1,
	gltd_class_2,
	ksop,
	helping_our_own,
	christmas_club_election,
	group_life_insurance
} = CorePlanShortDescription;

const {
	cancer,
	whole_life,
	short_term_disability,
	critical_illness,
	term_life_coverage,
	hospital_indemnity,
	accident,
	term_life_to_age_121,
	doc_and_rx,
	vision,
	dental,
	limited_indemnity_insurance
} = VebPlanShortDescription;

//===================================================planImage================================
const {
	health_plan: HP,
	clinic_card: CC,
	gstd: GSTD,
	gltd_class_1: GLTD1,
	gltd_class_2: GLTD2,
	ksop: KSOP,
	helping_our_own: HOO,
	christmas_club_election: CCE,
	group_life_insurance: GLI
} = CorePlanImage;

const {
	cancer: _cancer,
	whole_life: _whole_life,
	short_term_disability: _short_term_disability,
	critical_illness: _critical_illness,
	term_life_coverage: _term_life_coverage,
	hospital_indemnity: _hospital_indemnity,
	accident: _accident_insurance,
	limited_indemnity_insurance: _limited_indemnity_insurance,
	term_life_to_age_121: _term_life_to_age_121,
	doc_and_rx: _doc_and_rx,
	vision: _vision,
	dental: _dental
} = VebPlanImage;

// ========================================================================

export const FeaturedBenefitsPlanList: FeaturedBenefitsPlanListTypes = {
	corePlans: [
		{
			cardTitle: "Health Plan",
			cardImage: HP,
			cardDescription: health_plan,
			planType: "CORE",
			planRedirectionRoute: "health-plan"
		},
		{
			cardTitle: "Clinic Card Program",
			cardImage: CC,
			cardDescription: clinic_card,
			planType: "CORE",
			planRedirectionRoute: "clinic-card"
		},
		{
			cardTitle: "GSTD",
			cardImage: GSTD,
			cardDescription: gstd,
			planType: "CORE",
			planRedirectionRoute: "group-short-term-disability"
		}
	],
	vebPlans: [
		{
			cardTitle: "Group Limited Indemnity",
			cardImage: _limited_indemnity_insurance,
			cardDescription: limited_indemnity_insurance,
			planType: "VEB",
			planRedirectionRoute: "limited-indemnity"
		},
		{
			cardTitle: "Hospital Indeminity",
			cardImage: _hospital_indemnity,
			cardDescription: hospital_indemnity,
			planType: "VEB",
			planRedirectionRoute: "hospital-indemnity"
		},
		{
			cardTitle: "Accident",
			cardImage: _accident_insurance,
			cardDescription: accident,
			planType: "VEB",
			planRedirectionRoute: "accident-insurance"
		},

		{
			cardTitle: "Cancer",
			cardImage: _cancer,
			cardDescription: cancer,
			planType: "VEB",
			planRedirectionRoute: "cancer-plan"
		},
		{
			cardTitle: "Critical Illness",
			cardImage: _critical_illness,
			cardDescription: critical_illness,
			planType: "VEB",
			planRedirectionRoute: "critical-illness"
		},
		{
			cardTitle: "Short Term Disability",
			cardImage: _short_term_disability,
			cardDescription: short_term_disability,
			planType: "VEB",
			planRedirectionRoute: "short-term-disability"
		},
		{
			cardTitle: "Whole Life",
			cardImage: _whole_life,
			cardDescription: whole_life,
			planType: "VEB",
			planRedirectionRoute: "whole-life"
		},
		{
			cardTitle: "Term Life Coverage",
			cardImage: _term_life_coverage,
			cardDescription: term_life_coverage,
			planType: "VEB",
			planRedirectionRoute: "term-life-coverage"
		},
		{
			cardTitle: "Term Life To Age 121",
			cardImage: _term_life_to_age_121,
			cardDescription: term_life_to_age_121,
			planType: "VEB",
			planRedirectionRoute: "term-life-121"
		},

		{
			cardTitle: "Dental",
			cardImage: _dental,
			cardDescription: dental,
			planType: "VEB",
			planRedirectionRoute: "dental"
		},
		{
			cardTitle: "Vision",
			cardImage: _vision,
			cardDescription: vision,
			planType: "VEB",
			planRedirectionRoute: "vision"
		}
	]
};

export const CorePlansLists: FeaturedBenefits[] = [
	{
		cardTitle: "Health Plan",
		cardImage: HP,
		cardDescription: health_plan,
		planType: "CORE",
		planRedirectionRoute: "health-plan"
	},
	{
		cardTitle: "Clinic Card Program",
		cardImage: CC,
		cardDescription: clinic_card,
		planType: "CORE",
		planRedirectionRoute: "clinic-card"
	},
	{
		cardTitle: "GSTD",
		cardImage: GSTD,
		cardDescription: gstd,
		planType: "CORE",
		planRedirectionRoute: "group-short-term-disability"
	},
	{
		cardTitle: "GLTD (Class 1)",
		cardImage: GLTD1,
		cardDescription: gltd_class_1,
		planType: "CORE",
		planRedirectionRoute: "group-long-term-disability-class-1"
	},
	{
		cardTitle: "GLTD (Class 2)",
		cardImage: GLTD2,
		cardDescription: gltd_class_2,
		planType: "CORE",
		planRedirectionRoute: "group-long-term-disability-class-2"
	},
	{
		cardTitle: "KSOP",
		cardImage: KSOP,
		cardDescription: ksop,
		planType: "CORE",
		planRedirectionRoute: "ksop"
	},
	{
		cardTitle: "Helping Our Owm",
		cardImage: HOO,
		cardDescription: helping_our_own,
		planType: "CORE",
		planRedirectionRoute: "helping-our-own"
	},
	{
		cardTitle: "Christmas Club",
		cardImage: CCE,
		cardDescription: christmas_club_election,
		planType: "CORE",
		planRedirectionRoute: "christmas-club-election"
	},
	{
		cardTitle: "Group Life Insurance",
		cardImage: GLI,
		cardDescription: group_life_insurance,
		planType: "CORE",
		planRedirectionRoute: "group-life-insurance"
	}
];

export const VEBPlansLists: FeaturedBenefits[] = [
	{
		cardTitle: "Group Limited Indemnity",
		cardImage: _limited_indemnity_insurance,
		cardDescription: limited_indemnity_insurance,
		planType: "VEB",
		planRedirectionRoute: "limited-indemnity"
	},
	{
		cardTitle: "Hospital Indemnity",
		cardImage: _hospital_indemnity,
		cardDescription: hospital_indemnity,
		planType: "VEB",
		planRedirectionRoute: "hospital-indemnity"
	},
	{
		cardTitle: "Accident",
		cardImage: _accident_insurance,
		cardDescription: accident,
		planType: "VEB",
		planRedirectionRoute: "accident-insurance"
	},
	{
		cardTitle: "Cancer",
		cardImage: _cancer,
		cardDescription: cancer,
		planType: "VEB",
		planRedirectionRoute: "cancer-plan"
	},
	{
		cardTitle: "Critical Illness",
		cardImage: _critical_illness,
		cardDescription: critical_illness,
		planType: "VEB",
		planRedirectionRoute: "critical-illness"
	},
	{
		cardTitle: "Short Term Disability",
		cardImage: _short_term_disability,
		cardDescription: short_term_disability,
		planType: "VEB",
		planRedirectionRoute: "short-term-disability"
	},

	{
		cardTitle: "Whole Life",
		cardImage: _whole_life,
		cardDescription: whole_life,
		planType: "VEB",
		planRedirectionRoute: "whole-life"
	},
	{
		cardTitle: "Term Life Coverage",
		cardImage: _term_life_coverage,
		cardDescription: term_life_coverage,
		planType: "VEB",
		planRedirectionRoute: "term-life-coverage"
	},

	{
		cardTitle: "Term Life To Age 121",
		cardImage: _term_life_to_age_121,
		cardDescription: term_life_to_age_121,
		planType: "VEB",
		planRedirectionRoute: "term-life-121"
	},

	{
		cardTitle: "Dental",
		cardImage: _dental,
		cardDescription: dental,
		planType: "VEB",
		planRedirectionRoute: "dental"
	},
	{
		cardTitle: "Vision",
		cardImage: _vision,
		cardDescription: vision,
		planType: "VEB",
		planRedirectionRoute: "vision"
	},
	{
		cardTitle: "Doc and Rx",
		cardImage: _doc_and_rx,
		cardDescription: doc_and_rx,
		planType: "VEB",
		planRedirectionRoute: "doc-and-rx"
	}
];
